export const environment = {
  production: true,
  APIPath: 'https://fhirmmh.itri-nlp.tw/api',
  syncFileUploadUrl: '',
  CodeUrl: 'https://fhirmmh.itri-nlp.tw',
  VisualUrl: 'http://20.188.121.148:3000',
  Interval: 30,
};
